import React, { useContext, Fragment, useState } from "react";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import { isDisplayable } from "util/misc";
import { PlayByPlayContext } from "games/model/PlayByPlayContext";
import Play from "./PlayBase";
import PlayRow from "./PlayRow";

const PlayList = () => {
  const {
    usePlayByPlay: [state]
  } = useContext(PlayByPlayContext);
  const [showDialog, setShowDialog] = useState(false);
  const [playId, setPlayId] = useState(null);

  const { plays, game } = state;

  const handleCloseClick = () => {
    setShowDialog(false);
  };
  if (!isDisplayable(plays)) return null;
  return (
    <Fragment>
      <TableContainer component={Paper}>
        <Table>
          <TableHead>
            <TableRow>
              <TableCell>
                <abbr title="Quarter">Q</abbr>
              </TableCell>
              <TableCell>
                <abbr title="Team in Possession">TIP</abbr>
              </TableCell>
              <TableCell>
                <abbr title="Down">Dwn</abbr>
              </TableCell>
              <TableCell>
                <abbr title="Distance To Go">DTG</abbr>
              </TableCell>
              <TableCell>
                <abbr title="Yard Line">YL</abbr>
              </TableCell>
              <TableCell>Play Type</TableCell>
              <TableCell>Player(s)</TableCell>
              <TableCell>
                <abbr title="Length of Play">Lgth</abbr>
              </TableCell>
              <TableCell>
                <abbr title="Ball Spot">BS</abbr>
              </TableCell>

              <TableCell>
                <abbr title="Points Gained in this play">Score</abbr>
              </TableCell>
              {/* Edit Buttons */}
              <TableCell></TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {plays.map((play) => (
              <PlayRow
                key={play.id}
                play={play}
                game={game}
                setShowDialog={setShowDialog}
                setPlayId={setPlayId}
              />
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Play
        handleCloseClick={handleCloseClick}
        showDialog={showDialog}
        actionOnSubmit={"editPlay"}
        playId={playId}
        dialogTitle="Edit Play"
      />
    </Fragment>
  );
};

export default PlayList;
